import { type MoneyMapRuleType } from '@fruitful/types';
import React from 'react';
import { useThemeColors, View } from 'smoothie';

import Logo from '../../assets/fruitful-logo-icon-only.svg';
import { IncomeSplitOverviewColors } from '../types/IncomeSplitOverviewTypes';

export const IncomeSplitOverviewFruitfulLogo = ({
    moneyMapRuleType,
}: {
    moneyMapRuleType?: MoneyMapRuleType;
}) => {
    const { getColor } = useThemeColors();
    const resolveColor = (color: string) =>
        color.startsWith('$') ? getColor(color) : color;
    const bg =
        moneyMapRuleType != null
            ? IncomeSplitOverviewColors[moneyMapRuleType].background
            : '$peach';
    const fg =
        moneyMapRuleType != null
            ? IncomeSplitOverviewColors[moneyMapRuleType].foreground
            : '$peachDarkest';

    return (
        <View
            padding={4}
            alignItems="center"
            justifyContent="center"
            borderRadius={6}
            backgroundColor={bg}
        >
            <Logo width={16} height={16} fill={resolveColor(fg)} />
        </View>
    );
};
